<script setup>
import { router, usePage } from '@inertiajs/vue3'
import { ref } from 'vue'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/Components/ui/alert-dialog'

/**
 * Asked once per sign-in of a tutor Stripe cannot pay yet: students can only
 * book them once it can. The banner above every page stays as the reminder.
 */
const page = usePage()
const open = ref(
  page.props.flash?.payout_setup_prompt === true &&
    page.url !== '/teacher/settings/bank-details'
)

const setUp = () => router.visit('/teacher/settings/bank-details')
</script>

<template>
  <AlertDialog v-model:open="open">
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Set up your payouts</AlertDialogTitle>
        <AlertDialogDescription>
          Students can book you once Stripe, our payment provider, can pay you. It takes a few minutes, here in Bindle,
          from your Bank Details page.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Later</AlertDialogCancel>
        <AlertDialogAction @click="setUp">Set up payouts</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>
